import React from "react";
import {Asset, Link} from "../../../plugins/gatsby-plugin-atollon";
import parse from "html-react-parser";

const ProductCard = (props) => {
  return (
    <div className='card card--product'>
      <div className='card__product-image'>
        {props.gallery?.length > 0 && <Asset asset={props.gallery[0]}/>}
        {props.gallery?.length > 1 && 
          <div className='card__product-rollover'>
            <Asset asset={props.gallery[1]}/>
          </div>
        }
      </div>
      {props.title && <h4>{parse(props.title.replace(props.size, '', props.title))}</h4>}
      {props.size && <span>{props.size}</span>}
    </div>
  )
}

export default ProductCard